<div [formGroup]="form" *ngIf="fields && fields.length > 0">
  <div *ngFor="let field of fields; let i = index">
    <div class="wrapper" *ngIf="!field.hide">
      <ng-container [ngSwitch]="field.controlType">
        <ng-container *ngSwitchCase="'show'">
          <div class="firstPart" [ngStyle]="field.style">
            <label>{{ field.label }}</label>
          </div>
          <div class="secondPart" [ngStyle]="field.style">
            <label>{{ field.value }}</label>
          </div></ng-container
        >
        <ng-container *ngSwitchCase="'text'">
          <div class="firstPart" [ngStyle]="field.style">
            <label id="{{ field.formControlName }}">{{ field.label }}</label>
          </div>
          <div class="secondPart" [ngStyle]="field.style">
            <ng-container *ngIf="field.onlyShow">
              <label>{{ field.value }}</label>
            </ng-container>
            <ng-container *ngIf="!field.onlyShow">
              <input
                *ngIf="!field.onlyUpperCase"
                formControlName="{{ field.formControlName }}"
                name="{{ field.formControlName }}"
              />
              <input
                *ngIf="field.onlyUpperCase"
                toUppercase
                formControlName="{{ field.formControlName }}"
                name="{{ field.formControlName }}"
              />
            </ng-container></div
        ></ng-container>

        <ng-container *ngSwitchCase="'textarea'">
          <div class="firstPart" [ngStyle]="field.style">
            <label id="{{ field.formControlName }}">{{ field.label }}</label>
          </div>
          <div class="secondPart" [ngStyle]="field.style">
            <ng-container *ngIf="field.onlyShow">
              <label>{{ field.value }}</label>
            </ng-container>
            <ng-container *ngIf="!field.onlyShow">
              <textarea
                [ngStyle]="getCombinedStyles(field)"
                type="textarea"
                formControlName="{{ field.formControlName }}"
                name="{{ field.formControlName }}"
                maxlength="{{ field.label === 'Nuevo comentario' ? 500 : 512 }}"
                (input)="autoExpand($event)"
              ></textarea>
            </ng-container></div
        ></ng-container>

        <ng-container *ngSwitchCase="'selectorWithSearch'">
          <div class="firstPart" [ngStyle]="field.style">
            <label id="{{ field.formControlName }}">{{ field.label }}</label>
          </div>
          <div class="secondPart" [ngStyle]="field.style">
            <ng-container *ngIf="field.onlyShow">
              <label>{{ getSelectorVisibleValue(field) }}</label>
            </ng-container>
            <ng-container *ngIf="!field.onlyShow">
              <app-input-selector-with-search
                [list]="field.selectorList"
                [fields]="field.selectorFields"
                [id]="field.selectorId"
                [item]="field.selectorItem"
                (sendValue)="changeValueOfForm($event, field)"
              ></app-input-selector-with-search>
            </ng-container></div
        ></ng-container>
      </ng-container>
    </div>
  </div>
</div>
